import Vue from 'vue'

// State 工具函数
export function mapState(maps) {
  const states = {}
  const { state } = Vue.prototype.$store

  if (Array.isArray(maps)) {
    // maps: ['state1', 'state2']
    maps.forEach(key => {
      states[key] = () => state[key]
    })
  } else if (typeof maps === 'object') {
    Object.entries(maps).forEach(([key, val]) => {
      states[key] = function() {
        let valType = typeof val

        if (valType === 'function') {
          // maps: { state1 (state) { return state.state2 } }
          return val.call(this, state)
        } else if (valType === 'string') {
          // maps: { state1: 'state1-renamed' }
          return state[val]
        }
      }
    })
  }

  return states
}

// Getters 工具函数
export function mapGetters(maps) {
  const getterMap = {}
  const { getters } = Vue.prototype.$store

  if (Array.isArray(maps)) {
    // maps: ['getter1', 'getter2']
    maps.forEach(key => {
      getterMap[key] = () => getters[key]
    })
  } else if (typeof maps === 'object') {
    Object.entries(maps).forEach(([key, val]) => {
      getterMap[key] = function() {
        let valType = typeof val

        if (valType === 'function') {
          // maps: { getter1 (getters) { return getters.getter2 } }
          return val.call(this, getters)
        } else if (valType === 'string') {
          // maps: { getter1: 'getter-renamed' }
          return getters[val]
        }
      }
    })
  }

  return getterMap
}
